import React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

import { LucideProps } from "lucide-react";
interface MenuItemProps {
	title: string;
	href: string;
	icon?: React.ForwardRefExoticComponent<Omit<LucideProps, "ref"> & React.RefAttributes<SVGSVGElement>>;
	hasSmoothScroll?: boolean;
}

const MenuItem: React.FC<MenuItemProps> = ({ title, href, icon, hasSmoothScroll }) => {
	const smoothScrollToSection = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
		e.preventDefault();
		const targetId = href.substring(1); // Remove the '#' from the href
		const targetElement = document.getElementById(targetId);
		if (targetElement) {
			targetElement.scrollIntoView({ behavior: "smooth" });
		}
	};

	const isActive = location.pathname === href;

	return (
		<li className="px-3 py-2">
			<Link
				to={href}
				className={cn(
					"text-gray-700 hover:text-primary-500 transition-colors font-karla scroll-smooth uppercase",
					isActive
						? "bg-sage-100 text-sage-900"
						: "text-gray-600 hover:text-sage-900 hover:bg-sage-50",
				)}
				onClick={hasSmoothScroll ? smoothScrollToSection : undefined}
			>
				{!icon && <span>{title}</span>}

				{icon && React.createElement(icon, { className: "w-4 h-4" }) && (
					<div className="flex items-center space-x-2">
						{React.createElement(icon, { className: "w-4 h-4" })}
						<span>{title}</span>
					</div>
				)}
			</Link>
		</li>
	)
};


export default MenuItem;